if (!customElements.get('usp-slider')) {
  customElements.define(
    'usp-slider',
      class UspSlider extends HTMLElement {
        constructor() {
          super();
          this.attachShadow({ mode: 'open' });
          this.render();
        }

        render() {
          const slot = document.createElement('slot');
          this.shadowRoot.appendChild(slot);
          this.initializeSlider();
        }

        initializeSlider() {
          setTimeout(() => {
            const root = document.documentElement;
            const sliderElementsDisplayed = getComputedStyle(root).getPropertyValue("--slider-elements-displayed");
            const sliderContent = this.querySelector("ul.usp-slider__content");g

            root.style.setProperty("--slider-elements", sliderContent?.children?.length || 0);
            for (let i = 0; i < sliderElementsDisplayed; i++) {
              sliderContent?.appendChild(sliderContent?.children[i]?.cloneNode(true));
            }
          }, 100);
        }
      }
    );
}
